module.exports = "https://cdn.realtymogul.com/static/media/Get_Financing_Chart.686f7e59.png";